// import images from all-images/blog-img directory
import img01 from "../all-images/tours-img/hellsgate.png";
import img02 from "../all-images/tours-img/nairobicity.png";
import img03 from "../all-images/tours-img/nnp.png";
import img04 from "../all-images/tours-img/kibera.png";
import img05 from "../all-images/tours-img/amboseli.png";
import img06 from "../all-images/tours-img/ngong.png";

const tourData = [
  {
    id: 1,
    tourName: "Hell's Gate National Park",
    imgUrl: img01,
    tourLocation: "Nairobi, Kenya",
    includedActivities: [
      "Crescent Island Game Sanctuary",
      "Hells Gate National Park",
      "Hiking",
      "Game Drive",
      "Rock Climbing",
      "Maasai Cultural Tour",
      "Hot Springs",
      "Price is exclusive of Entrance Fee",
      "The Driver will stay with you for the whole day",
    ],
  },
  {
    id: 2,
    tourName: "Amboseli National Park",
    imgUrl: img05,
    tourLocation: "Nairobi, Kenya",
    includedActivities: [
      "Amboseli National Park",
      "Amboseli Serena Safari Lodge",
      "Price is exclusive of Entrance Fee",
      "Transport to & from Amboseli National Park",
      "Tour Guide",
      "Game Drive",
      "Nature Walk",
      "Bird Watching",
      "Cultural Tour",
    ],
  },
  {
    id: 3,
    tourName: "Nairobi National Park",
    imgUrl: img03,
    tourLocation: "Nairobi, Kenya",
    includedActivities: [
      "Nairobi Safari Walk",
      "Nairobi National Park",
      "Game Drive",
      "Walking Safari",
      "Bird Watching",
      "Entrance fee to the park is not inclusive",
      "Pick up and Drop off at CJ'S Kilimani or CBD",
    ],
  },
  {
    id: 4,
    tourName: "Kibera Community Tour",
    imgUrl: img04,
    tourLocation: "Nairobi, Kenya",
    includedActivities: [
      "Yaya Centre",
      "Kibera slums community development program",
      "You'll be driven around in most parts of Kibera in a Private Car",
      "Guided Walking Tour",
    ],
  },
  {
    id: 5,
    tourName: "Nairobi City Tour",
    imgUrl: img02,
    tourLocation: "Nairobi, Kenya",
    includedActivities: [
      "August 7th Memorial Park",
      "Museum Hill",
      "Uhuru Park",
      "Kenya Railway Museum",
      "Nairobi Gallery",
      "Kenyatta International Convention Centre",
      "City Market",
    ],
  },
  {
    id: 6,
    tourName: "Ngong Hills Hiking",
    imgUrl: img06,
    tourLocation: "Nairobi, Kenya",
    includedActivities: [
      "Ngong Hills",
      "Ngong Hills Forest Reserve",
      "Transport to and from Ngong Hill",
      "Free Drinking Water",
      "Price is exclusive of Entrance Fee ",
    ],
  },
];

export default tourData;
